import { features } from '@/mocks/home';

const iconBgColors = [
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-600',
  'bg-secondary-100 text-secondary-600',
  'bg-primary-100 text-primary-600',
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-star-line text-xs"></i>
            <span>核心优势</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            为什么选择古古漫画网
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            四大核心优势，打造极致漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((item, i) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7 hover:border-primary-200/60 hover:bg-background-100/80 transition-all duration-300"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg mb-5 group-hover:scale-110 transition-transform duration-300 ${iconBgColors[i % iconBgColors.length]}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2.5">{item.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}